import { createHyperscript } from "@convertkit/slate-hyperscript"
import htm from "htm"

export const create = options => {
  const h = createHyperscript(options)
  return htm.bind(h)
}

export const createHTM = function(options = {}) {
  return create({
    blocks: {
      button: "button",
      blockquote: "blockquote",
      blockquote_line: "blockquote-line",
      paragraph: "paragraph",
      heading_one: "heading-one",
      heading_two: "heading-two",
      heading_three: "heading-three",
      heading_four: "heading-four",
      heading_five: "heading-five",
      heading_six: "heading-six",
      html: "html",
      image: "image",
      captioned_image: "captioned-image",
      caption: "caption",
      code: "code",
      code_line: "code-line",
      unordered_list: "unordered-list",
      ordered_list: "ordered-list",
      list_item: "list-item",
      list_item_child: "list-item-child",
      video: "video",
      style: "style",
      ...options.blocks
    },
    inlines: {
      link: "link",
      ...options.inlines
    },
    marks: {
      bold: "bold",
      italic: "italic",
      underline: "underline",
      strikethrough: "strikethrough",
      color: "color",
      font_size: "font-size",
      inline_code: "inline-code",
      ...options.marks
    }
  })
}

export const html = createHTM()
